module.exports = __webpack_public_path__ + "static/media/icon-email-notify.e6ae5635.svg";